import { TextField } from "@mui/material";
import { styled } from "@mui/material/styles";

export const LoginTextField = styled(TextField)(({ theme }) => ({
    '& .MuiOutlinedInput-root': {
        '& fieldset': {
            borderColor: 'white',
            top: 0,
        },
        '& fieldset legend': {
            display: 'none',
        },
        '&:error fieldset': {
            borderColor: 'red',
        },
        '&:hover fieldset': {
            borderColor: 'white',
        },
        background: 'white',
        marginBottom: theme.spacing(2),
        padding: theme.spacing(1, 2),
        borderRadius: "35px",
    },
}));